import { authClient, sessionAuthorization, clearBrowserPasswordSession } from './auth';
import { installPinSession } from './pin-session';
import { sealCachedIdentity } from './oem-offline';
export interface PinDirectoryEntry {
  selector: string;
  label: string;
}
export interface PinMember {
  userId: string;
  name: string;
  label: string | null;
  enabled: boolean;
  version: number | null;
}
export const validStaffPin = (value: string) => /^[0-9]{6}$/.test(value);
export async function pinRequest(
  path: string,
  body?: unknown,
  authenticated = false,
): Promise<unknown> {
  const authorization = authenticated ? await sessionAuthorization() : undefined;
  const response = await fetch(
    `${import.meta.env.VITE_API_URL}${authenticated ? '/v1/oem' : '/v1/staff-pin'}${path}`,
    {
      method: body ? 'POST' : 'GET',
      headers: {
        ...(body ? { 'Content-Type': 'application/json' } : {}),
        ...(authorization ? { Authorization: authorization } : {}),
      },
      ...(body ? { body: JSON.stringify(body) } : {}),
      cache: 'no-store',
      referrerPolicy: 'no-referrer',
    },
  );
  const result = (await response.json()) as { data?: unknown };
  if (!response.ok)
    throw Error(
      authenticated
        ? 'ไม่สามารถจัดการ PIN ได้ กรุณาตรวจสอบสิทธิ์และชื่อที่ซ้ำ'
        : 'เข้าสู่ระบบไม่ได้ กรุณาตรวจสอบชื่อและ PIN หรือลองใหม่ภายหลัง',
    );
  return result.data;
}
export async function signInStaff(selector: string, pin: string) {
  if (!validStaffPin(pin) || !navigator.onLine || !authClient)
    throw Error('กรุณาเลือกชื่อและกรอก PIN 6 หลักขณะออนไลน์');
  const result = (await pinRequest('/exchange', { selector, pin })) as {
    token: string;
    expiresAt: string;
  };
  const previous = await authClient.auth.getSession();
  if (previous.data.session) await sealCachedIdentity(previous.data.session.user.id);
  // Clear this browser's old SDK credential, without revoking unrelated sessions.
  clearBrowserPasswordSession();
  localStorage.removeItem('sqi-active-project');
  installPinSession(result);
}
